<template>
    <div class="version2-middle-bottom">
        <div class="version2-middle-bottom-block">
            <div class="middle-title">
                <img src="../../../../../static/version1/标题箭头左.png" alt="">
                <span class="text">近十年专利申请量</span>
                <img src="../../../../../static/version1/标题箭头右.png" alt="">
            </div>
            <Bar :options="options" @echartClick="echartClick"></Bar>
        </div>
    </div>
</template>
<script>
import Bar from '@/components/echarts/Bar'
import { yearRange } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      options: {},
      typeList: [
        {
          name: '发明专利/件',
          label: 'invent',
          value: '发明申请',
          data: [],
          color: {
            type: 'linear',
            x: 0, // 右
            y: 0, // 下
            x2: 0, // 左
            y2: 1, // 上
            colorStops: [
              {
                offset: 0,
                color: '#0F3554' // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: '#129195' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#20DFDC' // 100% 处的颜色
              }
            ]
          },
          itemStyle: {
            borderColor: '#3681FF'
          }
        },
        {
          name: '实用新型/件',
          label: 'newKind',
          value: '实用新型',
          data: [],
          color: {
            type: 'linear',
            x: 0, // 右
            y: 0, // 下
            x2: 0, // 左
            y2: 1, // 上
            colorStops: [
              {
                offset: 0,
                color: '#123451' // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: '#8F8328' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#ECC21A' // 100% 处的颜色
              }
            ]
          },
          itemStyle: {
            borderColor: '#FFD736'
          }
        },
        {
          name: '外观设计/件',
          label: 'exterior',
          value: '外观设计',
          data: [],
          color: {
            type: 'linear',
            x: 0, // 右
            y: 0, // 下
            x2: 0, // 左
            y2: 1, // 上
            colorStops: [
              {
                offset: 0,
                color: '#103D5A' // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: '#14BCB4' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#31D8E2' // 100% 处的颜色
              }
            ]
          },
          itemStyle: {
            borderColor: '#36EAFF'
          }
        }
      ],
      xData: []
    }
  },
  components: {
    Bar
  },
  mounted() {
    this.getYearRange()
  },
  methods: {
    echartClick(params) {
      let exp = params.data.label
      if (params.data.label === '发明申请') {
        exp = '发明申请 or 发明授权'
      }
      this.jumpIpi(`专利类型=(${exp}) and 申请年=${params.name}`, 'isMerge')
    },
    getYearRange() {
      yearRange().then((res) => {
        //
        if (res[this.codeMapping]) {
          res[this.dataMapping].forEach((item) => {
            if (this.xData.every(items => items !== item.year)) {
              this.xData.push(item.year)
            }
          })
          res[this.dataMapping].forEach((item) => {
            this.typeList.forEach((ele) => {
              if (item.name === ele.label) {
                ele.data.push({value: item.count, label: ele.value})
              }
            })
          })
          this.getChart()
        }
      })
    },

    getChart() {
      const obj = {
        type: 'bar',
        stack: '',
        symbolSize: 8,
        smooth: false,
        emphasis: {
          focus: 'series'
        },
        barMaxWidth: 50,
        labelLayout: {
          hideOverlap: true
        },
        select: {},
        selectedMode: {
          focus: 'series'
        }
      }
      this.typeList = this.typeList.map(item => {
        return {...obj, ...item}
      })

      this.options = {
        // color: ['#00C8EF', '#00FFD0', '#00FF90'],
        tooltip: {
          trigger: 'axis',

          axisPointer: {
            lineStyle: {
              color: 'rgb(126,199,255)'
            }
          }
        },
        legend: {

          icon: 'roundRect',
          show: true,
          top: '2%',
          itemWidth: 20, // 图例标记的图形宽度。
          itemHeight: 10, //  图例标记的图形高度。
          itemGap: 30,
          itemStyle: {
            // color: ['#00C8EF', '#00FFD0', '#00FF90']
          },
          textStyle: {
            color: '#fff',
            fontSize: 14
          }
        },
        grid: {
          top: '25%',
          left: '10%',
          right: '4%',
          bottom: '20%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              // 坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                width: 2,
                color: '#CBD9DE'
              }
            },
            axisLabel: {
              // 坐标轴刻度标签的相关设置
              textStyle: {
                color: '#CBD9DE',
                fontSize: 12
              }
            },
            axisTick: {
              show: false
            },
            data: this.xData
          }
        ],
        yAxis: [
          {
            // interval: 500,
            name: '',
            nameTextStyle: {
              color: '#fff',
              fontSize: 12,
              padding: [0, 60, 0, 0]
            },
            // minInterval: 1,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: 'RGBA(51, 71, 85, .8)'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                width: 2,
                color: '#7E8E98'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#CBD9DE',
                fontSize: 14
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: this.typeList
      }
    }
  }
}
</script>
